
document.addEventListener( 'DOMContentLoaded', initmodal );


function initmodal() {
	const txtElements = document.querySelectorAll( '.simple-modal' ); 
	txtElements.forEach( ( txtElement ) => {   
		new SimModal( txtElement );
   
	} );
}

class SimModal{
  constructor( txtElement ){
    this.id = txtElement;
    this.buttonclose = txtElement.querySelectorAll('.btn-close')
    this.modal_name = txtElement.getAttribute('data-modal-name')
    if (this.modal_name) {  
      this.calling_btns = document.querySelectorAll( `.${this.modal_name}` )         
      this.events() 
    }
  }

  events() {     
    this.btnCalling()
    this.closeModal()
  }

  btnCalling(){  
    this.calling_btns.forEach((item)=>{
      item.style.cursor = 'pointer';
      item.addEventListener(('click'), (e)=>{
        this.openmodal( this.modal_name );
      })      
    }) 
  }
 
  closeModal() {
    this.buttonclose.forEach(( item )=>{
      item.addEventListener('click', (e)=>{
        this.findNearestModal(e.target).classList.remove('p-absolute')      
      } )
    } )
  }
  

  findNearestModal( el ) {
    let thisNote = el    
      while (!thisNote.classList.contains('simple-modal')){
        thisNote = thisNote.parentElement          
      }   
    return thisNote
  }


  openmodal(){
     
    document.querySelectorAll('.simple-modal').forEach(item =>{     
      item.classList.remove('p-absolute')     
    })
    this.id.classList.add('p-absolute') 
  }
  
 
}